/* eslint-disable */
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import jwtdecode from 'jwt-decode';
import { Box, Typography, LinearProgress } from '@mui/material';
import identifyPosthogUser from '../../utils/posthogIdentify';
import { loginSuccess, languagecodevalue } from '../../store/reducer';
import { getB2BCourseList, getB2BSAT, getCourseCompletion, getAllcourseDetails, getAllFreeCourses, getSatDetails, getOfferbaner } from '../../Redux/Action';
import loginServices from '../../services/loginServices';
import apiClient from '../../services/apiClient';
import { fetchBranding, storeBranding } from '../../services/brandingService';

export default function ExchangeOTT() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);

  useEffect(() => {
    const ott = searchParams.get('ott');
    const courseId = searchParams.get('courseId');
    const planId = searchParams.get('planId') || '';
    const redirect = searchParams.get('redirect');
    const urlRole = searchParams.get('role');


    if (!ott) {
      navigate('/login', { replace: true });
      return;
    }

    const existingToken = Cookies.get('token');

    if (existingToken && userInfo?.role) {
      const role = urlRole || userInfo.role;
      const userId = userInfo.id;
      if (role === 'AUTH_USER') {
        dispatch(getB2BCourseList(userId, 'paid'));
        dispatch(getB2BSAT(userId));
      } else if (role === 'USER_DTC') {
        dispatch(getCourseCompletion(userId));
        dispatch(getAllcourseDetails('en'));
        dispatch(getAllFreeCourses('en', userId));
      }
      const redirectUrl = getRedirectUrl(redirect, role, courseId, planId);
      navigate(redirectUrl, { replace: true });
      return;
    }

    fetch(`${process.env.REACT_APP_API_ENDPOINT}/authenticate/exchange-ott?ott=${ott}`)
      .then((r) => r.json())
      .then(async (data) => {

        if (!data.token) {
          navigate('/login', { replace: true });
          return;
        }

        apiClient.setHeader('Authorization', `BEARER ${data.token}`);
        Cookies.set('token', data.token);
        Cookies.set('refreshToken', data.refreshToken || data.token);
        Cookies.set('isLogIn', true);
        const decoded = jwtdecode(data.token);
        Cookies.set('tokenExpireTime', decoded.exp);

        const tenantSlug = window.location.hostname.split('.')[0];
        if (tenantSlug && tenantSlug !== 'localhost') {
          localStorage.setItem('tenant_kss', tenantSlug);
        }

        fetchBranding().then((r) => {
          if (r && r.ok && r.data) storeBranding(r.data);
        }).catch(() => {});

        const userRes = await loginServices.getUserInfo();

        if (!userRes.ok || !userRes.data?.role) {
          navigate('/login', { replace: true });
          return;
        }

        dispatch(loginSuccess(userRes.data));
        identifyPosthogUser(userRes.data);
        const role = urlRole || userRes.data.role;
        const userId = userRes.data.id;


        if (role === 'AUTH_USER') {
          dispatch(languagecodevalue('en'));
          dispatch(getB2BCourseList(userId, 'paid'));
          dispatch(getB2BSAT(userId));
          localStorage.setItem('selectedToggle', 'paid');
        } else if (role === 'USER_DTC') {
          dispatch(languagecodevalue('en'));
          dispatch(getCourseCompletion(userId));
          dispatch(getAllcourseDetails('en'));
          dispatch(getAllFreeCourses('en', userId));
          dispatch(getSatDetails(userId));
          dispatch(getOfferbaner());
          localStorage.setItem('selectedToggle', 'paid');
        }

        const redirectUrl = getRedirectUrl(redirect, role, courseId, planId);
        navigate(redirectUrl, { replace: true });
      })
      .catch((err) => {
        navigate('/login', { replace: true });
      });
  }, []);

  function getRedirectUrl(redirect, role, courseId, planId) {
    if (redirect === 'dashboard') return '/app/course';
    if (role === 'AUTH_USER') return `/app/course-details/${courseId}/${planId}`;
    if (role === 'USER_DTC') return `/auth/course-details/${courseId}/${planId}`;
    return '/app/course';
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', gap: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
        Redirecting to KeySkillSet...
      </Typography>
      <Typography variant="body2" sx={{ color: '#888' }}>
        Please wait while we set up your session
      </Typography>
      <Box sx={{ width: 300, mt: 2 }}>
        <LinearProgress />
      </Box>
    </Box>
  );
}